<template src="./TabDeliveriesComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {AppConstant, CommonText} from "@/supports/app.constant";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import IconRotateRight from "@/components/icons/IconRotateRight.vue";
import {computed, onMounted, reactive, ref, watch} from "vue";
import {useSyncKiotviet} from "@/stores/syncKiotviet.js";
import {ErrorText} from "@/supports/error-message.constant.js";
import {useAccountStore} from "@/stores/account.js";
import {useRouter} from "vue-router";
import ModalStoreWarehouseListComponent from "@/components/modals/modal-store-warehouse-list/ModalStoreWarehouseListComponent.vue";
import ModalWarehouseListComponent from "@/components/modals/modal-warehouse-list/ModalWarehouseListComponent.vue";

export default {
  name: 'TabDeliveriesComponent',
  components: {
    ModalWarehouseListComponent,
    ModalStoreWarehouseListComponent,
    IconRotateRight,
    InputCheckboxOne,
    InputDateTimeNormal,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  props: {
    tabCurrent: {
      type: Number,
      required: false,
      default: () => 1
    },
  },
  setup(props) {
    const errors = ref(true)
    const messError = ref('');
    const syncKiotvietStore = useSyncKiotviet()
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_SYNC_KIOTVIET))
    const selectLimit = ref(CommonService.showDropdownLimitRecord())
    const limitDefault = ref(0)
    const listItemSelected = ref([])
    const checkItems = ref({})
    const checkAll = ref(false)
    const urlOrigin = ref('/setting/sync-kiotviet');
    const accountStore = useAccountStore()
    const router = useRouter()
    const stateModal = reactive({
      modalStoreWarehouseList: null,
    })
    const typeSelectStoreWarehouse = ref('single')
    const eventClickShowModalStoreWarehouse = ref(false)
    const listStoreWarehousesSelected = ref([])
    const isLoading = ref(false)

    const dataPartner = ref({
      partner_id: {
        id: 'partner_id',
        label: 'Đối tác giao hàng',
        placeholder: 'Đối tác giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
    })
    const dataHeaderTable = ref({
      exchange_delivery_name: {
        label: 'Tên dữ liệu giao hàng',
        order: 2,
        width: '25%',
      },
      companyNameReceiver: {
        label: 'Đối tác',
        order: 3,
        width: '25%',
      },
      sumAmount: {
        label: 'Tổng tiền gốc',
        order: 4,
        width: '15%',
      },
      sumTaxAmount: {
        label: 'Tổng tiền <br> (bao gồm thuế)',
        order: 5,
        width: '15%',
      },
      status: {
        label: 'Trạng thái',
        order: 6,
        width: '15%',
      },
      timeCreated: {
        label: 'Ngày tạo phiếu',
        order: 7,
        width: '15%',
      },
      delivery_date: {
        label: 'Ngày chấp thuận',
        order: 8,
        width: '15%',
      },
      time_approved: {
        label: 'Ngày giao hàng',
        order: 9,
        width: '15%',
      },
    })

    watch(() => props.tabCurrent, (newTab) => {
      if(newTab === AppConstant.TAB_DELIVERY_KIOTVIET) {
        getListPartnerKiotviet();
      }
    });

    const removeError = () => {
      messError.value = '';
    };

    const listDataDelivery = computed(() => {
      return syncKiotvietStore.data_deliveries;
    });

    const paginate = computed(() => {
      return syncKiotvietStore.paginate_deliveries;
    });

    watch(() => syncKiotvietStore.data_deliveries, (newlistDataDelivery) => {
      newlistDataDelivery.forEach((delivery) => {
        if(checkItems.value[delivery.id] === undefined) {
          checkItems.value[delivery.id] = false
        }
      })
    });

    onMounted(() => {
      stateModal.modalStoreWarehouseList = new bootstrap.Modal('#modalStoreWarehouse', {})
    });

    function onChangeAction(value) {
      switch (parseInt(value)) {
        case AppConstant.ACTION_TYPE_SYNC_KIOTVIET:
          if (listItemSelected.value.length === 0) {
            CommonService.showAlertPopup({
              title: 'Vui lòng chọn dữ liệu để thực hiện!',
              icon: "warning",
              showConfirmButton: false,
              timer: 1500,
              width: '800px'
            });
          } else {
            showModalStoreWarehouseList()
          }
          break;
      }
    }

    function onChangeLimit(value) {
      const currentLimit = limitDefault.value
      limitDefault.value = value
      if(currentLimit > 0) {
        getListDataKiotviet(AppConstant.PAGE_DEFAULT, limitDefault.value)
      }
    }

    function onChangePartner(value, name) {
      dataPartner.value[name].value = value;
      getListDeliveryKiotvietByKiotvietPartnerId(value, router.currentRoute.value.query.page ?? AppConstant.PAGE_DEFAULT)
    }

    function validateForm(value, name) {
      if(name === 'partner_id') {
        dataPartner.value.partner_id.isError = false;
        dataPartner.value.partner_id.error = ''
        errors.value = false
        if(!value) {
          dataPartner.value.partner_id.isError = true;
          dataPartner.value.partner_id.error = ErrorText.REQUIRED(dataPartner.value.partner_id.label);
          errors.value = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function onChangeSelectAll(value) {
      checkAll.value = value
      listItemSelected.value = []
      listDataDelivery.value.forEach((delivery) => {
        checkItems.value[delivery.delivery_code] = value
        if (value) listItemSelected.value.push(delivery.delivery_code)
      })
    }

    function onChangeSelectItem(value, delivery_code) {
      checkItems.value[delivery_code] = value

      if (value) {
        if (!listItemSelected.value.includes(delivery_code)) {
          listItemSelected.value.push(delivery_code)
        }
      } else {
        const index = listItemSelected.value.indexOf(delivery_code)
        if (index !== -1) {
          listItemSelected.value.splice(index, 1)
        }
      }

      const allSelected = listDataDelivery.value.every(
          (item) => checkItems.value[item.delivery_code]
      )
      checkAll.value = allSelected
    }

    function emitPage(page) {
      const limit = limitDefault.value ?? 10;
      getListDeliveryKiotvietByKiotvietPartnerId(dataPartner.value['partner_id'].value, page, limit);
    }

    async function getListPartnerKiotviet() {
      const params = {
        m_company_id: accountStore.account.company.id
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/get-partner-sync-connected';
      await syncKiotvietStore.getListPartnerSyncKiotvietConnected(url, params);

      dataPartner.value.partner_id.options = []
      syncKiotvietStore.data_partners.forEach((partner) => {
        dataPartner.value.partner_id.options.push({
          name: partner.partner_name,
          value: partner.kiotviet_partner_id
        })
      })
    }

    async function getListDeliveryKiotvietByKiotvietPartnerId(kiotviet_partner_id, page = 0, take = 10)
    {
      const params = {
        m_company_id: accountStore.account.company.id,
        kiotviet_partner_id: kiotviet_partner_id,
        m_user_id: CommonService.getUserId(),
        page: page,
        take: take
      };

      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/get-delivery-kiotviet';
      return await syncKiotvietStore.getlistDataDelivery(url, params);
    }

    async function syncSelectedKiotvietDeliveries(payload = {}) {
      messError.value = '';

      // 1. Kiểm tra danh sách đơn hàng được chọn
      if (!listItemSelected.value || listItemSelected.value.length === 0) {
        messError.value = 'Vui lòng chọn ít nhất 1 đơn hàng để đồng bộ.';
        return;
      }

      // 2. Tạo params gửi API
      const params = {
        m_user_created_id: CommonService.getUserId(),
        m_company_id: accountStore?.account?.company?.id ?? null,
        delivery_ids: listItemSelected.value,
        company_code: accountStore?.account?.company?.company_zip ?? '',
        kiotviet_partner_id: dataPartner.value?.['partner_id']?.value ?? null,
        store_id: payload?.store_id ?? null,
        warehouse_id: payload?.warehouse_id ?? null,
      };

      const url = `${AppConstant.URL_API_LOCAL}api/v1/sync-kiotviet/sync-deliveries`;

      try {
        const result = await syncKiotvietStore.syncDeliveries(url, params);
        if (result?.status === 'success') {
          CommonService.showAlertPopup({
            title: result?.message || 'Đồng bộ thành công!',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
            width: '800px',
          });
          getListDeliveryKiotvietByKiotvietPartnerId(dataPartner.value['partner_id'].value);
          stateModal.modalStoreWarehouseList.hide()
        } else {
          messError.value = result?.message || 'Đồng bộ thất bại. Vui lòng thử lại.';
        }
      } catch (error) {
        console.error('[SYNC KIOTVIET ERROR]:', error);
        messError.value = 'Lỗi hệ thống hoặc kết nối mạng. Vui lòng thử lại.';
      }
    }


    function redirectToDetail(deliveryCode) {
      const routeData = router.resolve({
        name: 'DeliveryKiotvietDetail',
        query: {
          'delivery_code': deliveryCode,
          'm_company_id': accountStore.account.company.id,
          'partner_select_id': dataPartner.value['partner_id'].value
        }
      });

      window.open(routeData.href, '_blank');
    }

    function showModalStoreWarehouse(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalStoreWarehouse.value = false
          isLoading.value = false
          stateModal.modalStoreWarehouseList.show()
        }, 1000);
        return;
      }
      stateModal.modalStoreWarehouseList.hide()
    }

    function showModalStoreWarehouseList() {
      eventClickShowModalStoreWarehouse.value = true
      isLoading.value = true
    }

    return {
      dataHeaderTable,
      CommonService,
      CommonText,
      messError,
      removeError,
      listDataDelivery,
      selectAction,
      selectLimit,
      paginate,
      onChangeAction,
      onChangeLimit,
      dataPartner,
      onChangePartner,
      validateForm,
      errors,
      checkSubmitActive,
      onChangeSelectAll,
      checkAll,
      checkItems,
      onChangeSelectItem,
      emitPage,
      urlOrigin,
      redirectToDetail,
      showModalStoreWarehouse,
      typeSelectStoreWarehouse,
      listStoreWarehousesSelected,
      eventClickShowModalStoreWarehouse,
      syncSelectedKiotvietDeliveries
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;

  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }

  .container-fluid {
    padding-top: 30px;

    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46, 35, 94, .07);

      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;

        .list-product-component {
          margin-top: 30px;

          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }

          table {
            display: block;
            overflow-x: auto;
            white-space: nowrap;

            td {
              max-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;

            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
